import { createSelector } from 'reselect';
import orderBy from 'lodash/orderBy';

// const placeIdSelector = ({selectedPlace}) => selectedPlace.id;

const allThemesSelector = ({ schema }, { theme }) => {
  return schema[theme].byId;
}; // {id: {lodge},}

const themeIdsForSelectedPlaceSelector = ({ schema }, { placeId, theme }) => {
  return schema.places.byId[placeId][theme] || [];
  // array of lodge id for a place
};

const sortBySeletors = ({ selectedPlace }, { theme }) => selectedPlace[theme].sortBy;
const sortOrderSeletors = ({ selectedPlace }, { theme }) => selectedPlace[theme].sortOrder;
// const searchTermSelector = ({ selectedPlace }, { theme }) =>
//   selectedPlace[theme].searchTerm;

export const getSortedThemes = createSelector(
  [
    allThemesSelector,
    themeIdsForSelectedPlaceSelector,
    sortBySeletors,
    sortOrderSeletors,
    // searchTermSelector
  ],
  (allThemes, themeIds, sortBy, sortOrder) => {
    let themesArray = themeIds && themeIds.map(id => allThemes[id]);
    if (sortBy === 'name' && sortOrder === 'asc')
      themesArray = orderBy(themesArray, ['name'], ['asc']);
    if (sortBy === 'name' && sortOrder === 'desc')
      themesArray = orderBy(themesArray, ['name'], ['desc']);
    // if (searchTerm && searchTerm.length > 0) {
    //   themesArray = themesArray.filter(
    //     card => `${card.name}`.toUpperCase().indexOf(searchTerm.toUpperCase()) >= 0
    //   );
    // }
    return themesArray;
  }
);



// WEBPACK FOOTER //
// ./src/redux/selectors/PlacesThemeSorters.js